var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGreenLigth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#B6BA3A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4,
    fill: "#B6BA3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGreenLigth);
export default __webpack_public_path__ + "static/media/circle-green-ligth.253a6b3a9a347a18c3d925e8891ae3f3.svg";
export { ForwardRef as ReactComponent };